import { render, staticRenderFns } from "./zhanneixin_page.vue?vue&type=template&id=23a2fec3&scoped=true"
import script from "./zhanneixin_page.vue?vue&type=script&lang=js"
export * from "./zhanneixin_page.vue?vue&type=script&lang=js"
import style0 from "./zhanneixin_page.vue?vue&type=style&index=0&id=23a2fec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2fec3",
  null
  
)

export default component.exports